import Image from 'global/Image';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import {
  IconContainer,
  ButtonUnstyled,
  Divider,
} from './styled';

interface ItemInfoActionProps {
  onClick: () => void;
  title: string;
  description: string;
  iconName: string;
  id: string;
}

function ItemInfoAction({
  onClick,
  title,
  description,
  iconName,
  id,
}: ItemInfoActionProps) {
  return (
    <>
      <Divider />
      <Flex id={`${id}-container`}>
        <ButtonUnstyled onClick={onClick} id={`${id}-button`}>
          <Flex align="center" justify="space-between">
            <Flex align="center">
              <IconContainer>
                <Image src={`/icon/${iconName}.svg`} />
              </IconContainer>
              <Flex direction="column">
                <Text
                  family="bold"
                  size="13px"
                  height="18px"
                  weight="700"
                  color={color.highempahis}
                  id={`${id}-title`}
                >
                  {title}
                </Text>
                <Text
                  size="11px"
                  height="15px"
                  weight="400"
                  color={color.highgray}
                  id={`${id}-description`}
                >
                  {description}
                </Text>
              </Flex>
            </Flex>
            {onClick && (
              <IconWrapper id={`${id}-next-icon`}>
                <Iconmoon
                  className="icon-toolbar_next"
                  size="16px"
                  color={color.highgray}
                  hoverColor={color.highgray}
                />
              </IconWrapper>
            )}
          </Flex>
        </ButtonUnstyled>
      </Flex>
    </>
  );
}

export default ItemInfoAction;
